import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ProductAction } from '../../actions';
import { NoRecord } from '../../pages/HomePage';
import ProductInfoAutoDiagnosisItem from './ProductInfoAutoDiagnosisItem';
import { Translate as t } from '../../config/Translate';

const ProductInfoAutoDiagnosis = ({ product, GetProductDia }) => {

	const [list, setList] = useState(product.autoDiagnoses || []);
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    console.log("product.autoDiagnoses : ====================================", product.autoDiagnoses);
    if (product.autoDiagnoses) {
      const sortedList = [...product.autoDiagnoses].sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });
      setList(sortedList);
    } else {
      setList([]);
    }
  }, [product.autoDiagnoses]);

	const loadMoreData = async () => {
		if (isLoading || !hasMore) return;

		setIsLoading(true);
		const nextPage = currentPage + 1;

		await GetProductDia(
			{
				sn: product.sn,
				page: nextPage,
				itemperpage: 20
			},
			product.sn,
			true // append = true
		);

		setCurrentPage(nextPage);
		setIsLoading(false);
	};


	useEffect(() => {
		if(product.sn && product.cnt_dia) {
			setCurrentPage(1);
			setHasMore(true);
			GetProductDia(
				{
					sn: product.sn,
					page: 1,
					itemperpage: 20
				},
				product.sn,
				false // append = false
			);
		}
	}, [product.sn, product.cnt_dia]);

	useEffect(() => {
		// product.cnt_dia와 현재 로드된 데이터 개수 비교
		if(product.sn && product.autoDiagnoses && product.cnt_dia) {
			setHasMore(product.autoDiagnoses.length < product.cnt_dia);
		}
	}, [product.autoDiagnoses, product.cnt_dia]);

	return (
		<>
			{list.length > 0 &&
				<div className="section">
					<div className="accordion mt-1">
						{list.map((x, index) => <div className="accordion-item" key={x.timestamp}><ProductInfoAutoDiagnosisItem item={x} showindex={index} /></div>)}
					</div>
					{hasMore && (
						<div className="text-center mt-3">
							<button
								className="btn btn-primary"
								onClick={loadMoreData}
								disabled={isLoading}
							>
								{isLoading ? t('common.status.loading') : t('product.button.loadMore').replace('{count}', 20)}
							</button>
						</div>
					)}
				</div>
			}
			{!list.length &&
				<NoRecord />
			}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	GetProductDia: (filter, sn, append) => dispatch(ProductAction.GetProductDia(filter, sn, append))
});

export default connect(null, mapDispatch)(ProductInfoAutoDiagnosis);
